import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader-service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-loader',
  imports: [CommonModule, RouterModule, NgxSpinnerModule],
  standalone: true,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})


export class LoaderComponent implements OnInit {
  loading$!: any;  // ✅ Declare without initialization

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loading$ = this.loaderService.loading$;  // ✅ Initialize inside ngOnInit
  }

  // getRandomSpinnerType(){
  //   const spinnerTypes = [
  //     'ball-scale-multiple',
  //     'ball-clip-rotate',
  //     'ball-clip-rotate-pulse',
  //     'ball-clip-rotate-multiple',
  //     'ball-spin-clockwise',
  //     'ball-spin-counterclockwise',
  //     'ball-spin-clockwise-fade',
  //     'ball-spin-counterclockwise-fade',
  //     'ball-spin-clockwise-fade-rotating',
  //     'square-jelly-box',
  //     'square-spin',
  //     'timer',
  //     'line-scale',
  //     'line-scale-party',
  //     'line-scale-pulse-out',
  //     'line-scale-pulse-out-rapid',
  //     'line-spin-fade-loader',
  //     'triangle-skew-spin',
  //     'pacman',
  //     'ball-grid-beat',
  //     'ball-grid-pulse',
  //     'ball-pulse',
  //     'ball-pulse-sync',
  //     'ball-beat',
  //     'ball-scale',
  //     'ball-scale-ripple',
  //     'ball-scale-ripple-multiple',
  //     'ball-triangle-path',
  //     'ball-rotate',
  //     'ball-zig-zag',
  //     'ball-zig-zag-deflect',
  //     'ball-cube-transition',
  //     'ball-fall',
  //     'ball-fusion',
  //     'ball-swapping',
  //     'cube-transition',
  //     'ball-pulse-rise',
  //     'ball-pulse-round'
  //   ];
  //   return spinnerTypes[Math.floor(Math.random() * spinnerTypes.length)];
  // }
}

